import { render, staticRenderFns } from "./AllocationDetail.vue?vue&type=template&id=000eec7c&scoped=true"
import script from "./AllocationDetail.vue?vue&type=script&lang=js"
export * from "./AllocationDetail.vue?vue&type=script&lang=js"
import style0 from "./AllocationDetail.vue?vue&type=style&index=0&id=000eec7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000eec7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000eec7c')) {
      api.createRecord('000eec7c', component.options)
    } else {
      api.reload('000eec7c', component.options)
    }
    module.hot.accept("./AllocationDetail.vue?vue&type=template&id=000eec7c&scoped=true", function () {
      api.rerender('000eec7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/AllocationDetail.vue"
export default component.exports